import { AttachmentFileSet } from 'api';

import { FileData, FileUploadState } from './Types';

export const mapFileUploadStateToAttachmentFileSet = (
	fileState: FileUploadState,
	isAdditionalFiles = false
): AttachmentFileSet => ({
	profilePicturePath: null, // only used in unit registration
	folderName: fileState.attachmentFolderName,
	uploadedFiles: fileState.filesUploaded
		.filter((f) => f.isAdditional === isAdditionalFiles)
		.map((fileData) => fileData.serverName),
});

export const mapFileUploadListToRequestFileNames = (
	fileList: FileData[]
): string[] => {
	return fileList.map((fileData) => fileData.serverName);
};
